export function buildQueryParams(data: Record<string, string | undefined>): string {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(data)) {
    if (value !== undefined) {
      params.append(key, value)
    }
  }
  return params.toString()
}
